import { employees } from 'modules/users/employees/store/reducer';
import { managers } from 'modules/users/managers/store/reducers';
import { combineReducers } from 'redux';

export const usersModule = combineReducers({
    employees,
    managers,
});
